import React from "react";
import { useAuth } from "../../AuthContext";
import EventSettingsScreenContainer from "@/components/EventSettingsScreenContainer";
import { SettingsPage } from "@/components/settings/SettingsPage";
import UpdateProfileForm from "../../shared/UpdateProfileForm";
import { t } from "@/localization";

// Profile › Update Profile.
const UpdateEmail = () => {
  const {
    email,
    account_type,
    first_name,
    last_name,
    broadcaster_role,
    role_other,
    company_name,
    logo_path,
    company_url,
    no_branding,
    refetchProfile,
    profileLoaded,
    broadcaster,
  } = useAuth();

  return (
    <EventSettingsScreenContainer
      fallbackRoute="Profile"
      loading={!profileLoaded}
    >
      <SettingsPage title={t("Profile")}>
        {profileLoaded && (
          <UpdateProfileForm
            profile={{
              email,
              account_type,
              first_name,
              last_name,
              broadcaster_role,
              role_other,
              company_name,
              company_url,
              no_branding,
            }}
            logo_path={logo_path}
            broadcaster={broadcaster}
            refetchProfile={refetchProfile}
          />
        )}
      </SettingsPage>
    </EventSettingsScreenContainer>
  );
};

export default UpdateEmail;
